
    import './styles.scoped.css';
    export default {
  "help-panel": "awsui_help-panel_1d237_krmwe_94",
  "header": "awsui_header_1d237_krmwe_258",
  "content": "awsui_content_1d237_krmwe_284",
  "footer": "awsui_footer_1d237_krmwe_295"
};
  